<template>
  <div class="select" :style="{marginRight: mr, marginTop: mt, marginBottom: mb, maxWidth: maxWidth, width}">
    <select
        @change="$emit('change', $refs.select.value)"
        ref="select"
        :value="value"
        :placeholder="123"
    >
      <option v-if="placeholder" value="" disabled selected>{{placeholder}}</option>
      <slot></slot>
    </select>
  </div>
</template>

<script>
  export default {
    name: 'custom-select',
    props: {
      mr: String,
      mt: String,
      mb: String,
      placeholder: String,
      value: [String, Number],
      maxWidth: String,
      width: String,
    }
  }
</script>

<style scoped lang="scss">
  .select {
    height: 50px;
    width: 100%;
    max-width: 250px;
    background-color: #fff;
    select {
      position: relative;
      border: 1px solid #DBBFA7;
      box-sizing: border-box;
      border-radius: 5px;
      width: 100%;
      height: 100%;
      cursor: pointer;
      padding-left: 20px;
      background-color: transparent;
      font-size: 16px;
      color: #383838;
      z-index: 2;
      appearance: none;
      font-family: "Open Sans", sans-serif;
    }

    position: relative;
    &:after {
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      position: absolute;
      z-index: 1;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url(../../../assets/images/icons/chevron-down-black.svg);
    }
  }
</style>
